import Posts from "./Posts.json";

function TestimonialPosts({ index }) {
  return (
    <>
      <div id="demo" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">
          {Posts.map((post, index) => (
            <div
              key={post.id} // ✅ move key here
              className={`carousel-item ${index === 0 ? "active" : ""}`} // optional: make first slide active
            >
              <div
                className="d-block text-center"
                style={{ padding: 50, backgroundColor: "#f8f9fa" }}
              >
                <h3>{post.name}</h3>

                <div>{post.post}</div>
              </div>

              {/* Left and right controls */}
              <button
                className="carousel-control-prev"
                style={{ backgroundColor: "#2B679A", width: "40px" }}
                type="button"
                data-bs-target="#demo"
                data-bs-slide="prev"
              >
                <span className="carousel-control-prev-icon"></span>
              </button>
              <button
                className="carousel-control-next"
                style={{ backgroundColor: "#2B679A", width: "40px" }}
                type="button"
                data-bs-target="#demo"
                data-bs-slide="next"
              >
                <span className="carousel-control-next-icon"></span>
              </button>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default TestimonialPosts;
